import { lazy } from "react";

const SystemSupportFaqPage = lazy(
  () => import("@/widgets/system-admin/support-faq/SupportFaqPage"),
);

const SystemSupportFaqRoutes = {
  path: "support-faq",
  children: [{ index: true, element: <SystemSupportFaqPage /> }],
};

export default SystemSupportFaqRoutes;
